export default __webpack_public_path__ + "static/SubpageBanners_Insurance-86ad4af32c192055840f51ba95a58216.jpg";